// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accept_btn{
    background-color: #F15E22;
}
.accept_btn, .reject_btn{
width: 180px;
}
.accept_header{
    padding: 20px 20px 0 20px;
    font-size: 20px;
    font-weight: 600;
    line-height: 25.2px;
}
.accept_subheader{
    padding: 8px 20px 4px 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
}
.button_section{
    padding: 20px 20px 14px 20px;
    display: flex;
    justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/components/acceptPopup/acceptPopup.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;AACA;AACA,YAAY;AACZ;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;AAClC","sourcesContent":[".accept_btn{\n    background-color: #F15E22;\n}\n.accept_btn, .reject_btn{\nwidth: 180px;\n}\n.accept_header{\n    padding: 20px 20px 0 20px;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 25.2px;\n}\n.accept_subheader{\n    padding: 8px 20px 4px 20px;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n}\n.button_section{\n    padding: 20px 20px 14px 20px;\n    display: flex;\n    justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
